<template lang="pug">
  div#memo-dialog
    el-dialog(
      :visible.sync="dialogVisible"
      width="60%"
      top="10vh"
      :close-on-click-modal="false"
      @close="close")
      el-form(ref="dialogform" :model="dataSource" :rules="rules"  label-position="right" label-width="100px" :size="GLOBAL.SIZE_OF_INPUTBOX")
        el-row
          el-col(:span="14")
            el-form-item(label="标题" prop="title")
              el-input(v-model="dataSource.title" :disabled="this.isDisabled")
        el-row
          el-col(:span="14")
            el-form-item(label="作者" prop="author")
              el-input(v-model="dataSource.author" placeholder='请输入作者' :disabled="this.isDisabled")
        el-row
          el-col(:span="22")
            el-form-item(label="文本" )
              el-radio(v-model="memos._class"
                v-for="item in MEMO_CLASS"
                :key="item.value"
                :label="item.value"
                :disabled="isDisabled") {{ item.label }}
              el-input(type="textarea"
                :rows="6"
                placeholder="请输入内容"
                v-model="memos.content" prop="content" :disabled="this.isDisabled")
        el-row
          el-col(:span="4")
            el-form-item
              el-upload.upload-demo.memo-upload(ref="upload"
                :action="GLOBAL.uploadHost + 'internalMemo/upload'"
                :limit="10"
                :headers="headers"
                :on-success="success"
                multiple
                :auto-upload ="true"
                :before-upload="beforeUpload"
                :before-remove="beforeRemove"
                :fileList="fileList")
                el-button(type="primary" round :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled="this.isDisabled") 附件
          el-col(:span="20")
            el-row
              el-col(:span="8")
                el-form-item(label="文件名" label-width="75px")
                  el-input(v-model="memos.fileName" placeholder='请输入文件名')
              el-col(:span="12")
                el-form-item(label="文件地址" label-width="80px")
                  el-autocomplete.autocomplete-filename(v-model="memos.path" :fetch-suggestions="querySearchAsync" :trigger-on-focus="false" :hide-loading="true" placeholder='请输入文件地址')
              el-col(:span="2")
                el-tooltip(content="添加URL" placement="right")
                  el-button(type="success" icon="el-icon-check" size="mini" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="addUrl")
        el-row
          el-col(:span="22" style="text-align: right;")
            el-button(type="primary" icon='el-icon-plus' :size="GLOBAL.SIZE_OF_INPUTBOX" @click="plus" :disabled="this.isDisabled") 添加
        el-row(style="margin-top: 16px;")
          el-col(:span="22")
            el-form-item(label='列表')
              div.filter-list
                span(v-if="dataSource.memos && dataSource.memos.length === 0" style="margin-left: 10px;font-size:14px") 暂无
                div.paragraph(v-for="(text, index) in dataSource.memos" style="padding: 10px;")
                  span.content {{text._class | getClass}}: {{text.content}}
                  br
                  template(v-for="(tag, tagIndex) in text.attachments")
                    div
                      el-tag(:closable="!isDisabled" :disable-transitions="false" :size="GLOBAL.SIZE_OF_INPUTBOX"  @close="handleDeleteTag(index,tag)" style="margin-right:10px" @click="downloadFile(tag)") {{tag.fileName}}
                      span {{ tag.path }}
                  .btn-group
                    el-button(icon="el-icon-edit" type='primary' round
                      :size="GLOBAL.SIZE_OF_INPUTBOX" @click="editContent(text, index)" :disabled="isDisabled")
                    el-button.delete(icon="el-icon-delete" round :size="GLOBAL.SIZE_OF_INPUTBOX"
                      @click="deleteContent(index)" :disabled="isDisabled")
      .dialog-footer(slot="footer")
        el-button(:size="GLOBAL.SIZE_OF_INPUTBOX" @click="dialogVisible=false") 关闭
        el-button(type="danger" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="handleDelete" :disabled="this.isDisabled") 删除
        el-button(type="primary" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="handleSave" style="margin-left:10px"  :disabled="this.isDisabled") 保存
    editMemoDialog(
      :dialogVisible.sync="editVisible"
      :currentMemo="currentMemo"
      @updateMemo="updateMemo"
    )
</template>
<script>
import Enum from '@/apis/enum'
import api from '../apis/internalMemo'
import passport from '@/javascripts/passport'
import InputTag from '@/components/InputTag'
import editMemoDialog from '@/components/editMemoDialog'
import apis from '@/apis/apis'
export default {
  components: { InputTag, editMemoDialog },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    relativeId: {
      type: String,
      default: ''
    },
    index: {
      type: Number
    },
    title: {
      type: String
    }
  },
  data () {
    return {
      MEMO_CLASS: Enum.MEMO_CLASS,
      // relativeId: '5deda53f84279931e432473b',
      memos: { content: '', _class: 0, attachments: [] },
      dataSource: {
        title: '',
        memos: []
      },
      rules: {
        title: { required: true, message: '请输入标题', trigger: 'blur' }
      },
      headers: passport.headers(),
      fileList: [],
      dialogVisible: false,
      editVisible: false,
      currentMemo: null
    }
  },
  methods: {
    // 显示dialog以及内容
    show () {
      this.$nextTick(() => {
        this.dataSource.title = this.title
        api.getMemoByRelativeId({ id: this.relativeId }).then(r => {
          if (r.data) {
            this.dataSource = r.data
          }
          this.dialogVisible = true
        })
      })
    },
    // 文件上传验证
    beforeUpload (file) {
      const isLimit = file.size / 1024 / 1024 < 100
      if (!isLimit) {
        this.$message({
          type: 'warning',
          message: '上传文件大小不能超过100MB!',
          showClose: true
        })
        return isLimit
      }
    },

    // 移除文件
    beforeRemove (file) {
      if (file) {
        const idx = this.fileList.findIndex(item => item.uid === file.uid)
        this.fileList.splice(idx, 1)
        this.memos.attachments.splice(idx, 1)
      }
    },
    // 更新某项Memo
    updateMemo (data) {
      const index = this.currentMemo.index
      this.$set(this.dataSource.memos, index, { ...data })
    },
    // 保存
    handleSave () {
      this.$refs.dialogform.validate(valid => {
        if (valid) {
          if (this.dataSource.memos.length !== 0) {
            // _id 存在，则为修改
            if (this.dataSource._id) {
              api.saveMemo(this.dataSource).then(r => {
                if (r) {
                  this.$message({
                    message: '更新成功',
                    type: 'success'
                  })
                  this.dialogVisible = false
                  this.$emit('showMemo', true)
                }
              })
            } else {
              this.dataSource.relativeId = this.relativeId
              api.addInternalMemo(this.dataSource).then(r => {
                if (r) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                  this.dialogVisible = false
                  this.$emit('showMemo', true)
                }
              })
            }
          } else {
            this.$message({
              message: '请输入文本内容或插入附件',
              type: 'warning'
            })
          }
        }
      })
      // this.$refs.upload.clearFiles()
    },

    // 上传成功
    success (r) {
      if (r.data) {
        const { path, fileName } = r.data
        this.memos.attachments.push(r.data)
        this.fileList.push({ url: path, name: fileName })
      } else {
        this.$message.error(r.msg)
      }
    },
    // 删除附件便标签
    handleDeleteTag (index, tag) {
      if (this.dataSource.memos[index].attachments.length === 1 && !this.dataSource.memos[index].content) {
        return this.$message.warning('该项只有一项附件且无文本，不可删除')
      }
      const idx = this.dataSource.memos[index].attachments.findIndex(item => item._id === tag._id)
      this.dataSource.memos[index].attachments.splice(idx, 1)
    },
    // 添加到下面
    plus () {
      if (this.memos.content === '' && this.memos.attachments.length === 0) {
        this.$message({
          message: '请输入文本内容或插入附件',
          type: 'warning'
        })
      } else {
        this.dataSource.memos.push({ content: this.memos.content, _class: this.memos._class, attachments: this.memos.attachments })
        this.memos = { content: '', _class: 0, attachments: [] }
        this.fileList = []
        this.$refs.upload.clearFiles()
      }
    },
    // 前端删除文本内容
    deleteContent (index) {
      this.dataSource.memos.splice(index, 1)
    },

    close () {
      this.dataSource = { title: '', memos: [] }
      this.memos = { content: '', _class: 0, attachments: [] }
      this.fileList = []
      this.$refs.upload.clearFiles()
    },
    // 删除
    handleDelete () {
      // todo: 提示信息有问题
      this.$confirm('此操作将该附件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.deleteMemo({ id: this.dataSource._id }).then(r => {
          if (r) {
            this.$message({
              message: '删除成功,',
              type: 'success'
            })
            this.dialogVisible = false
            this.$emit('showMemo', false)
          }
        }).catch(err => {
          this.$message({
            message: '删除失败,' + err.message,
            type: 'error'
          })
        })
      }).catch(() => { // todo: 不需要
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    downloadFile (tag) {
      api.downloadAttac({ path: tag.path }).then(r => {
        const buf = Buffer.from(r.data.content, 'binary')
        const blob = new Blob([buf])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.setAttribute('download', tag.fileName)
        a.href = url
        a.click()
      })
    },
    addUrl () {
      const { path, fileName } = this.memos
      if (!path || !fileName) {
        return this.$message.warning('文件名及文件地址不能为空！')
      }
      this.memos.attachments.push({ path, fileName })
      this.fileList.push({ url: path, name: fileName })
      this.memos.path = ''
      this.memos.fileName = ''
    },

    querySearchAsync () {
      if (this.memos.path === '') return
      apis.handleAutoComplete({ text: this.memos.path }, '/internalMemo/getFileName').then(res => {
        const current = res.data.find(item => item.path === this.memos.path)
        if (current) {
          this.$set(this.memos, 'fileName', current.fileName)
        }
      })
    },
    // 编辑项
    editContent (memo, index) {
      this.currentMemo = { memo, index }
      this.editVisible = true
    }
  }
}
</script>

<style scoped >
.filter-list {
  font-size: 16px;
  max-height: calc(100vh - 500px);
  overflow: auto;
  background: rgba(245,245,245,.6);
  border-radius: 5px;
  border: 1px solid #eee;
}
.filter-list .btn-group {
  text-align: right;
}
.filter-list  .paragraph {
  padding: 10px;
  border-bottom: 1px solid #dcdfe6;
}
.filter-list  .paragraph:last-of-type {
  border-bottom: 0;
}
.content {
  text-indent: 2rem;
  line-height: 1.5;
  font-size: 14px;
}
.el-tag {
  cursor: pointer;
}
.delete {
  margin-left: 10px;
}
</style>

<style>
.upload-demo.memo-upload .el-upload-list.el-upload-list--text {
  width: 650px;
}
#memo-dialog .el-form-item--small.el-form-item {
  margin-bottom: 10px;
}
.autocomplete-filename {
  width: 100%;
}
</style>
